import { ObjectTools } from "../../tools";
import { wrapAsArray } from "../tools/collection.array.tools";

export class DataModel<T> {

    public onCreate: (item: T[]) => Promise<void> = () => { return Promise.resolve();/** Nothing by default */ };
    public onUpdate: (item: T[], propertyName: keyof T, value: T[keyof T]) => Promise<void> = () => { return Promise.resolve();/** Nothing by default */ };
    public onDelete: (item: T[]) => Promise<void> = () => { return Promise.resolve();/** Nothing by default */ };

    /**
     * Data of DataModel
     */
    private _data: T[] = [];

    private _elementTypeName: string;

    /**
     * Constructor for datamodel
     * @param elementTypeName 
     * @param options
     * @param options.comparator used to sort current data in setData and addItemOrArray 
     */
    constructor(elementTypeName = "", public options?: { comparator?: (t1: T, t2: T) => number }) {
        this._elementTypeName = elementTypeName;
    }

    /**
     * Returns element type name
     */
    public get elementTypeName(): string {
        return `${this._elementTypeName}`;
    }

    /**
     * Get values of field from data objects
     * @param propertyName
     * @param data
     */
    public getPropertyValue<K extends keyof T>(propertyName: K, data: T[]): T[K][] {
        return this.getItems(data).map((item: T) => item[propertyName]);
    }

    /**
     * Set property value for items in parameter
     *
     * @param propertyName field of data object to update value
     * @param data data object to update
     * @param value new value to set
     */
    public async setPropertyValue<K extends keyof T>(propertyName: K, data: T[], value: T[K]): Promise<void> {

        let itemsToSetPropertyValue = data;
        if (Array.isArray(value)) { // value is an array in referenceListEditor
            // TODO compare arrays to filter data
        } else {
            itemsToSetPropertyValue = this.getItems(data).filter(item => item[propertyName] !== value);
        }

        await this.onUpdate(itemsToSetPropertyValue, propertyName, value).then(() => {
            for (const item of itemsToSetPropertyValue) {
                item[propertyName] = value;
            }
        });
    }

    /**
     * Set DataModel data
     */
    public setData(data: T[]): void {
        this._data = data;
        if (this.options?.comparator) {
            this._data.sort(this.options.comparator);
        }
    }

    /**
     * Retrieve a copy of current data value in DataModel, 
     * Copy is without reference so data can't be updated this way
     */
    public getDataCopy(): T[] {
        return [...this._data];
    }

    /**
     * Access current data in DataModel
     */
    // TODO BGS
    public accessData(): T[] {
        return this._data;
    }

    /**
     * Add item to data list
     * @param itemOrArray Item or Array to add
     */
    public addItemOrArray(itemOrArray: T | T[]): void {

        const itemsToAdd: T[] = [];
        for (const item of wrapAsArray(itemOrArray)) {
            // Retrieve duplicates items
            const duplicateItemList = this._data.filter((data) => ObjectTools.deepEqual(data, item));
            // Add if no duplicate
            if (duplicateItemList.length === 0) {
                this._data.push(item);
                itemsToAdd.push(item);
            }
        }
        if (this.options?.comparator) {
            this._data.sort(this.options.comparator);
        }
        if (itemsToAdd.length) { this.onCreate(itemsToAdd); }
    }

    /**
     * Delete item in data list
     *
     * @param items Array containing objects to delete
     */
    public deleteItems(items: T[]): void {
        for (const item of items) {
            const indexToDelete = this._data.indexOf(item);
            if (indexToDelete === -1) { continue; }
            this._data.splice(indexToDelete, 1);
        }
        this.onDelete(items);
    }

    /**
     * Get items from array of editedData
     */
    public getItems(data: T[]): T[] {
        if (!data[0]) { return []; }

        // Compare all objects of both array, to retrieve items stored in DataModel
        const items = this._data.filter((item: T) => data.find((dataItem: T) => ObjectTools.deepEqual(item, dataItem)));// FIXME deepEqual !
        return items ? items : [];
    }
}